import withIntersectionDetection from './withIntersectionDetection';
import ProductsGridItem from './ProductsGridItem';

export default withIntersectionDetection(ProductsGridItem);
